function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m20.903 24.014 2.959-3.984 3.475-3.32s-1.158-1.381-2.59-1.381c-.643 0-1.232.184-1.77.552-.535.367-1.023.918-1.463 1.655-.615.215-1.094.42-1.438.615-.076-.766-.168-1.333-.275-1.7l1.996-7.748c.473-1.868.586-2.812-.539-3.312s-2.275.879-2.867 2.637l-1.893 5.983.057-7.694c0-1.889-.596-2.833-1.788-2.833-1.204 0-1.805.837-1.805 2.51v7.692l-1.936-6.738c-.48-1.192-1.325-2.366-2.45-1.991s-1.072 2.226-.76 3.411l1.725 6.569-2.782-4.595c-.851-1.475-2.319-1.76-2.651-1.416-.529.549-.883 1.717.077 3.394l3.069 5.343 2.74 9.492v1.845h8v-2.379c.929-.637 1.732-1.506 2.909-2.607z"
});

var SvgHand = function SvgHand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hand.eadb239a.svg";
export { ForwardRef as ReactComponent };